import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import "./MensagemBalao.css";

function formatarTamanho(bytes) {
  if (!bytes) return "0 KB";
  if (bytes < 1024 * 1024) return `${Math.ceil(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function escaparRegex(valor) {
  return valor.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// Mensagens antigas (antes do editor parar de embutir a legenda do anexo no
// corpo) ainda trazem o texto "nome (tamanho)" solto no mensagem_html. A
// miniatura ja mostra essa legenda, entao removemos a duplicata do corpo.
function removerLegendasAnexos(html, anexos) {
  let resultado = html || "";
  (anexos || []).forEach((anexo) => {
    if (!anexo?.nome) return;
    const legenda = `${anexo.nome} (${formatarTamanho(anexo.tamanho)})`;
    resultado = resultado.replace(new RegExp(escaparRegex(legenda), "g"), "");
  });
  return resultado;
}

function AnexosRenderizados({ anexos, onAbrirPreview }) {
  const lista = Array.isArray(anexos) ? anexos : [];
  if (lista.length === 0) return null;
  return (
    <div className="mensagem-balao-anexos">
      {lista.map((anexo, index) => {
        const tipo = anexo?.tipo || "";
        const nome = anexo?.nome || `anexo-${index + 1}`;
        const src = anexo?.conteudo_base64 ? `data:${tipo};base64,${anexo.conteudo_base64}` : null;
        return (
          <div
            className="mensagem-balao-anexo"
            key={`${nome}-${index}`}
            onClick={(e) => {
              e.stopPropagation();
              if (src) onAbrirPreview({ src, nome, tipo });
            }}
            role={src ? "button" : undefined}
            tabIndex={src ? 0 : undefined}
          >
            {src && tipo.startsWith("image/") && <img src={src} alt={nome} />}
            {src && tipo.startsWith("video/") && <video src={src} controls />}
            <span>{nome} ({formatarTamanho(anexo?.tamanho)})</span>
          </div>
        );
      })}
    </div>
  );
}

// Balao de mensagem com preview resumido (texto truncado) e clique para abrir
// a mensagem completa, incluindo o HTML formatado por inteiro e os anexos
// (imagens/videos) renderizados de verdade, nao so o nome do arquivo.
function MensagemBalao({ mensagem, autor, className, titulo }) {
  const [expandido, setExpandido] = useState(false);
  const [preview, setPreview] = useState(null);
  const anexos = Array.isArray(mensagem.anexos_json) ? mensagem.anexos_json : [];
  const dataFormatada = mensagem.created_at ? new Date(mensagem.created_at).toLocaleString("pt-BR") : "";
  const htmlLimpo = removerLegendasAnexos(mensagem.mensagem_html, anexos) || "<p>Sem conteudo.</p>";
  const origemClasse = mensagem.origem === "GODMODE" ? "mensagem-balao-godmode" : "mensagem-balao-usuario";

  return (
    <>
      <article
        className={`mensagem-balao ${origemClasse} ${className || ""}`}
        onClick={() => setExpandido(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setExpandido(true);
        }}
      >
        <header>
          <strong>{autor}</strong>
          <span>{dataFormatada}</span>
        </header>
        <div className="mensagem-balao-html mensagem-balao-resumo" dangerouslySetInnerHTML={{ __html: htmlLimpo }} />
        {anexos.length > 0 && (
          <small className="mensagem-balao-anexos-hint">
            {anexos.length === 1 ? "1 anexo" : `${anexos.length} anexos`} - clique para ver completo
          </small>
        )}
      </article>

      <Modal show={expandido} onHide={() => setExpandido(false)} size="lg" centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>{titulo || autor}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mensagem-balao-meta">
            <strong>{autor}</strong>
            <span>{dataFormatada}</span>
          </div>
          <div className="mensagem-balao-html" dangerouslySetInnerHTML={{ __html: htmlLimpo }} />
          <AnexosRenderizados anexos={anexos} onAbrirPreview={setPreview} />
        </Modal.Body>
      </Modal>

      <Modal show={Boolean(preview)} onHide={() => setPreview(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{preview?.nome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {preview && preview.tipo.startsWith("image/") && (
            <img src={preview.src} alt={preview.nome} className="mensagem-balao-preview-media" />
          )}
          {preview && preview.tipo.startsWith("video/") && (
            <video src={preview.src} controls autoPlay className="mensagem-balao-preview-media" />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setPreview(null)}>Fechar</Button>
          {preview && (
            <Button as="a" href={preview.src} download={preview.nome}>
              <FiDownload /> Baixar
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MensagemBalao;
